<template>
    <div id="app">
     <!-- 面包屑导航 -->
     <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>个人中心</el-breadcrumb-item>
     </el-breadcrumb>
     <el-form label-width="120px" style="margin-top: 40px;" :data="userForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名：">
              <div>{{ userForm.username }}</div>
            </el-form-item>
            <el-form-item label="姓名：">
              <div>{{ userForm.real_name }}</div>
            </el-form-item>
            <el-form-item label="角色：">
              <div>{{ userForm.role_name }}</div>
            </el-form-item>
            <el-form-item label="性别：">
              <div>{{ userForm.sex_name }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：">
             <div>{{ userForm.mobile }}</div>
            </el-form-item>
            <el-form-item label="邮件：">
              <div>{{ userForm.email }}</div>
            </el-form-item>
            <el-form-item label="上次登录时间：">
              <div>{{ userForm.last_login_time }}</div>
            </el-form-item>
            <el-form-item label="上次登录IP：">
              <div>{{ userForm.last_login_ip }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button size="mini" type="primary" @click="handleEdit">编辑信息</el-button>
          <el-button size="mini" type="warning" @click="handleResetPwd">修改密码</el-button>
        </el-form-item>
    </el-form>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm" :rules="infoFormRules">
            <el-form-item label="姓名" prop="real_name">
               <el-input size="small" v-model="infoForm.real_name" auto-complete="off" placeholder="请填写真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="infoForm.sex">
                <el-radio v-model="infoForm.sex" :label="1">男</el-radio>
                <el-radio v-model="infoForm.sex" :label="2">女</el-radio>
                <el-radio v-model="infoForm.sex" :label="3">保密</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
             <el-input size="small" v-model="infoForm.mobile" auto-complete="off" placeholder="请填写手机号"></el-input>
            </el-form-item>
            <el-form-item label="邮件" prop="email">
              <el-input size="small" v-model="infoForm.email" auto-complete="off" placeholder="请填写邮件"></el-input>
            </el-form-item>
            <el-form-item>
            <el-button size="mini" type="primary" @click="submitInfoForm('infoForm')">保存</el-button>
            <el-button size="mini" @click='closeDialog("infoForm")'>取消</el-button>
            </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 修改密码界面 -->
    <el-dialog :title="title" :visible.sync="pwdFormVisible" width="50%" @click="closeDialog('pwdForm')">
      <el-form label-width="120px" :model="pwdForm" ref="pwdForm" :rules="pwdFormRules">
            <el-form-item label="新密码" prop="pwd">
               <el-input size="small" v-model="pwdForm.pwd" auto-complete="off" placeholder="请填写新密码"></el-input>
            </el-form-item>
            <el-form-item>
            <el-button size="mini" type="primary" @click="submitPwdForm('pwdForm')">保存</el-button>
            <el-button size="mini" @click='closeDialog("pwdForm")'>取消</el-button>
            </el-form-item>
      </el-form>
    </el-dialog>

    <!-- <iframe id="show-iframe" class="show-iframe" frameborder=0 name="showHere" src="https://resources.qzhip.com/snow_flake/index.html"></iframe> -->
    </div>
</template>

<script>
import { userInfo, editUserInfo, resetUserPwd } from '../../api/userMG'
import { checkLogin } from '../../utils/util'
import md5 from 'js-md5'

export default {
    data() {
        return {
            editFormVisible: false,// 控制编辑页面是否显示
            pwdFormVisible: false,// 控制编辑页面是否显示
            // mainWidth: this.$refs.main.clientWidth,
            // mainHeight: this.$refs.main.clientHeight,
            title: '',// 弹窗标题
            userForm: {},
            infoForm: {
                real_name : '',
                sex : '',
                mobile : '',
                email : '',
            },
            pwdForm: {
                pwd: ''
            },
            // 表单验证
            infoFormRules: {
                 real_name: [{required: true, message: '请输入真实姓名', trigger: 'blur'}],
                 sex: [{required: true, message: '请选中性别', trigger: 'blur'}],
                 mobile: [{required: true, message: '请输入手机号', trigger: 'blur'}],
                 email: [{required: true, message: '请输入邮箱', trigger: 'blur'}],
            },
            pwdFormRules: {
                 pwd: [{required: true, message: '请输入新密码', trigger: 'blur'}],
            }

        }
    },
     /**
   * 创建完毕
   */
    created() {
        this.getdata()
    },

    /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取管理员信息
    getdata(){
        const param = {}
         userInfo(param)
        .then(res => {
          res = checkLogin(res)
          if (res.code == 200) {
            this.userForm = res.data
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.$message.error('系统错误！')
        })
    },
    handleEdit:function(){
        this.title = '编辑用户'
        this.infoForm.real_name = this.userForm.real_name
        this.infoForm.sex = this.userForm.sex
        this.infoForm.mobile = this.userForm.mobile
        this.infoForm.email = this.userForm.email
        this.editFormVisible = true
    },
    submitInfoForm:function(infoForm){
        this.$refs[infoForm].validate(valid => {
            if (valid) {
                editUserInfo(this.infoForm)
                    .then(res => {
                    this.editFormVisible = false
                    res = checkLogin(res)
                    if (res.code == 200) {
                        this.getdata()
                        this.$message({
                        type: 'success',
                        message: res.msg
                        })
                    } else {
                        this.$message({
                        type: 'info',
                        message: res.msg
                        })
                    }
                    })
                    .catch(err => {
                    this.editFormVisible = false
                    this.$message.error('系统错误！')
                    })
            } else {
            return false
            }
            })
    },
    handleResetPwd:function(){
        this.title = '修改密码'
        this.pwdFormVisible = true
    },
    submitPwdForm:function(pwdForm){
        this.$refs[pwdForm].validate(valid => {
            if (valid) {
                this.pwdForm.pwd = md5(this.pwdForm.pwd)
                resetUserPwd(this.pwdForm)
                    .then(res => {
                    this.pwdFormVisible = false
                    res = checkLogin(res)
                    if (res.code == 200) {
                        this.getdata()
                        this.$message({
                        type: 'success',
                        message: res.msg
                        })
                    } else {
                        this.$message({
                        type: 'info',
                        message: res.msg
                        })
                    }
                    })
                    .catch(err => {
                    this.pwdFormVisible = false
                    this.$message.error('系统错误！')
                    })
            } else {
            return false
            }
            })
    },
     // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'infoForm') {
        this.editFormVisible = false
      } else if (dialog == 'pwdForm') {
        this.pwdFormVisible = false
      }
    },
  },
  // mounted(){
  //   const oIframe = document.getElementById('show-iframe');
  //   const oApp = document.getElementById('app');
  //   // const deviceWidth = document.getElementById('app').style.width;
  //   // const deviceHeight = document.documentElement.el-amin.height;
  //   console.log('width:'+oApp.style.width+';height:'+oApp.style.height)
  //   oIframe.style.width = oApp.style.width + 'px';
  //   oIframe.style.height = oApp.style.height + 'px';
  //   oIframe.style.zIndex = -99;
  //   oIframe.style.marginLeft = -20;
  //   oIframe.style.marginTop = -877;
  // },
}
</script>
<style>
  /* .el-main {
      background-color: #f0f2f5;
  } */

  .show-iframe {
    width: 87vw;
    height: 100vh;
    z-index: -10;
    margin-left: -20px;
    margin-top: -101vh;
  }
  .index-main {
    z-index: 999;
  }
</style>


// WEBPACK FOOTER //
// src/views/index/content.vue